var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-indicator',{class:_vm.classForMatchConfidence,attrs:{"text":_vm.confidenceFormat}})
}
var staticRenderFns = []

export { render, staticRenderFns }